import React, { Component } from 'react';
import {Route, Link} from 'react-router-dom';

import './NanumGothic.scss';

class NanumGothic extends Component {
  render() {
    const {input, onChange} = this.props;

    return (
      <li>
        <Link to="/nanum_gothic/detail">
          <div className="dashed-wrap nanum_gothic">
            <h4 className="content-title">
              <span className="font-company">Naver, Sandoll</span>
              <span className="font-title">나눔 고딕 / Nanum Gothic</span>
            </h4>
            <p className="font-text">{input}</p>
          </div>
        </Link>
      </li>
    );
  }
}

export default NanumGothic;